import React from "react";
import LeagueWizard from "./wizard/LeagueWizard";

// Route entry for /contest/create-public-league.
//
// Public and private leagues are ONE flow — same inputs, same steps, same
// validation — so all of it lives in LeagueWizard and only the copy, the league
// link prefix (qushi.io/leagues/) and the post-submit destination come from the
// `public` variant in wizard/leagueWizardConfig.js. Change shared behaviour
// there, not here, or the two flows drift apart again.
const CreatePublicLeagueWizard = () => <LeagueWizard variant="public" />;

export default CreatePublicLeagueWizard;
